import { NgModule } from "@angular/core";
import { DashComponent } from "./dash.component";
import { CommonModule } from "@angular/common";
import { PoIconModule, PoModule, PoPageDefaultComponent } from "@po-ui/ng-components";
import { PoTemplatesModule } from "@po-ui/ng-templates";

@NgModule({
    declarations: [DashComponent],
    exports: [DashComponent,
        PoPageDefaultComponent],
    imports: [
        CommonModule,
        PoModule,
        PoIconModule,
        PoTemplatesModule,
    ]
})
export class DashModule { }
